import { Base } from '@/models/base.model.js';
import { Address } from '@/models/address.model.js';

export class Company extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.name = obj.name;
		this.industry = obj.industry;
		this.rates = obj.rates;
		this.email = obj.email;
		this.contact = obj.contact;
		this.address = new Address(obj.address);
		this.managers = obj.managers;
	}
}

export default Company;
